import React from "react";
import { Link } from "react-router-dom";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link to="/" className="text-sm text-blue-500 hover:underline">
          ← Back to RushGro
        </Link>

        <h1 className="text-4xl font-bold mt-6 mb-2">
          Refund & Cancellation Policy
        </h1>

        <p className="text-muted-foreground mb-10">
          Last updated: 24 August 2026
        </p>

        <div className="space-y-8 text-sm leading-7">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Scope</h2>
            <p>
              This policy applies to eligible payments made for RushGro
              subscriptions and services unless different refund or
              cancellation terms are specified in a quotation, agreement,
              invoice or service contract.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              2. Subscription Cancellation
            </h2>
            <p>
              Customers requesting cancellation should contact RushGro in
              accordance with the notice period and termination conditions
              specified in their applicable subscription or service
              agreement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              3. Refund Eligibility
            </h2>
            <p>
              Refund eligibility will depend on the nature of the payment,
              service activation status, asset installation, applicable
              contractual commitments and any costs already incurred by
              RushGro.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              4. Non-Refundable Charges
            </h2>
            <p>
              Installation charges, logistics expenses, activation charges,
              customization costs, consumed subscription periods, penalties
              and other costs already incurred may be non-refundable unless
              otherwise agreed in writing.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              5. Duplicate or Incorrect Payments
            </h2>
            <p>
              If a customer is charged more than once for the same
              transaction or makes an identifiable incorrect payment, the
              customer should contact RushGro with transaction details for
              verification.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              6. Refund Processing
            </h2>
            <p>
              Approved refunds will normally be processed through the
              appropriate payment method or agreed settlement method after
              verification. Processing times may vary depending on banks,
              payment providers and other third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              7. Asset Return
            </h2>
            <p>
              Where cancellation requires the return or removal of RushGro
              equipment, settlement or refund processing may be subject to
              successful inspection, recovery and closure of outstanding
              obligations relating to the asset.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              8. Contact for Refund Requests
            </h2>
            <p>
              Refund and cancellation requests should be sent to:
            </p>

            <p className="mt-3">
              RushGro<br />
              Email: support@rushgro.com<br />
              Website: rushgro.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}